export enum CallTypeCode {
  BYOT_IN = 'ByotIn',
  BYOT_OUT = 'ByotOut',
  BYOT_OUT_EMERGENCY = 'ByotOutEmergency',
  BYOT_OUT_USER_CONF = 'ByotOutUserConf',
  BYOT_OUT_USER_FORWARDING = 'ByotOutUserForwarding',
  BYOT_OUT_USER_TRANSFER = 'ByotOutUserTransfer',

  CONF_IN = 'conf_in',
  CONF_OUT = 'conf_out',

  DR_EMERGENCY_OUT = 'dr_emergency_out',
  DR_IN = 'dr_in',
  DR_IN_BOT = 'dr_in_bot',
  DR_OUT = 'dr_out',
  DR_OUT_BOT = 'dr_out_bot',
  DR_OUT_USER_CONF = 'dr_out_user_conf',
  DR_OUT_USER_FORWARDING = 'dr_out_user_forwarding',
  DR_OUT_USER_TRANSFER = 'dr_out_user_transfer',
  DR_UNASSIGNED_IN = 'dr_unassigned_in',

  EMERGENCY_IN = 'emergency_in',
  EMERGENCY_OUT = 'emergency_out',

  FMC_IN = 'fmc_in',
  FMC_OUT = 'fmc_out',

  UCAP_IN = 'ucap_in',
  UCAP_OUT = 'ucap_out',
  UCAP_OUT_CONF = 'ucap_out_conf',

  UNASSIGNED_IN = 'unassigned_in',

  USER_IN = 'user_in',
  USER_OUT = 'user_out',
  USER_OUT_CONF = 'user_out_conf',
  USER_OUT_FORWARDING = 'user_out_forwarding',
  USER_OUT_TRANSFER = 'user_out_transfer',
}
